import * as React from "react";
import { ListItemProps } from "./types";

const className = "scd-list-item";

export default function CustomListItem(
  props: ListItemProps,
): React.JSX.Element {
  const { children } = props;
  return <li className={className}>{children}</li>;
}
